import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialog: {
    width: '400px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  autocomplete: {
    width: '100%',
    marginBottom: '20px',
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.gray_50.main,
      borderRadius: '8px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.blue_300.main
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.blue_300.main
      },
      '& .MuiOutlinedInput-input': {
        padding: '10px !important',
        color: theme.palette.gray_400.main
      }
    },
    '& .MuiInputLabel-outlined': {
      color: theme.palette.gray_400.main
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: theme.palette.blue_300.main
    },
    '& .MuiAutocomplete-clearIndicator': {
      color: theme.palette.gray_400.main
    },
    '& .MuiAutocomplete-popupIndicator': {
      color: theme.palette.gray_400.main
    }
  },
  chip: {
    backgroundColor: '#eee',
    textShadow: '1px 1px 1px #000',
    color: 'white'
  },
  radio: {
    '&.MuiRadio-root': {
      color: theme.palette.blue_300.main,
      padding: 0,
      marginRight: 4,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18
    },
    '&.Mui-checked': {
      color: theme.palette.blue_300.main
    }
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: '8px'
  },
  statusDotOnline: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.green_200.main,
    display: 'inline-block',
  },
  statusDotOffline: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.red_100.main,
    display: 'inline-block',
  },
  userStatus:{
    fontSize: '.775rem'
  }
}))
